import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PbiReportViewModel } from '@rsmus/ecp-userservice'
import type { RootState } from '..'

interface ReportData {
  reportId: string
  reportName: string | undefined
  embedUrl: string
  accessToken: string
  tokenExpiration: string
  hasAdminRole: boolean
  pbiReports: PbiReportViewModel[] | undefined
}

// Define a type for the slice state
interface ReportState {
  reportData: ReportData
  adminSelectedReportId: number | undefined
}

// Define the initial state using that type
const initialState: ReportState = {
  reportData: {
    reportId: '',
    reportName: '',
    embedUrl: '',
    accessToken: '',
    tokenExpiration: '',
    hasAdminRole: false,
    pbiReports: [],
  },
  adminSelectedReportId: undefined,
}

export const reportSlice = createSlice({
  name: 'report',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setReportData: (state, action: PayloadAction<ReportData>) => {
      state.reportData = action.payload
    },
    setAdminSelectedReportId: (
      state,
      action: PayloadAction<number | undefined>,
    ) => {
      state.adminSelectedReportId = action.payload
    },
  },
})

export const { setReportData } = reportSlice.actions
export const getReportData = (state: RootState) => state.report.reportData

export const { setAdminSelectedReportId } = reportSlice.actions
export const getAdminSelectedReportId = (state: RootState) =>
  state.report.adminSelectedReportId
